/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 공통적으로 사용될 수 있는 간단한 형태의 모달창
 * 버전 : 1.0
 * 파일명 : CommonModals.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-12-18
 * ================================================================ 
 * 수정일 : 2025-12-29, 강동형, 두개 버튼 Footer가 스타일을 받도록 변경
 * 수정일 : 2025-02-04, 강동형, Common_ModalTitle_AlertCircle 추가, 두개버튼 Footer의 박스가 스타일을 받도록 변경
 * ================================================================ */

import styled from "styled-components"
import type React from "react"
import { CancleButton, NextButton } from "../common/CommonStyled"
import { AppImage } from "src/assets/images/AppImage"

// ======================================Header=============================================
const TitleWrapperInput = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    font-size: 18px;
    font-weight: 600;
    color: #000;
`
type TitleSimpleProps = {
    title:string
    showClose? : boolean
    customStyle?: React.CSSProperties
    action?:()=>void
}
export const Common_ModalTitle_Simple = ({title,showClose=true,customStyle,action}:TitleSimpleProps)=>{
    // const modalSetField = useModalStore(s=>s.setField)
    // const onClickaction =()=>{
    //     if(action){
    //         action?.()
    //         return
    //     }
    //     modalSetField('open',false)
    // }
    return(
        <TitleWrapperInput style={customStyle}>
            <span>{title}</span>
            {/* {showClose && <AppImage name="XMark" onClick={onClickaction} customStyle={{scale:'1.2'}}/>} */}
        </TitleWrapperInput>
    )
}

export const Common_ModalTitle_AlertCircle = ({title,showClose=false,customStyle,action}:TitleSimpleProps)=>{
    return(
        <TitleWrapperInput style={{ gap: "12px",justifyContent:'center', ...customStyle}}>
            <AppImage name='AlertCircle'/>
            {title}
        </TitleWrapperInput>
    )
}

// ======================================Content=============================================

const Common_ModalContent_ErrWarpper = styled.div`
    padding: 20px 0px;
    display: flex;
    flex-direction: column;
    gap: 19px;
`

type Common_ModalContent_ErrProps = {
    detail : string
    content : string
}

export const Common_ModalContent_Err = ({detail,content}:Common_ModalContent_ErrProps) =>{
    return(
        <Common_ModalContent_ErrWarpper>
            <span>{detail}</span>
            <span>{content}</span>
        </Common_ModalContent_ErrWarpper>
    )
}
const ContentWrapper = styled.div`
    padding: 20px 0px;
    white-space: pre-wrap; /* \n을 줄바꿈으로 */
    word-break: keep-all;
`
type ContentSimpleProps = {
    content:string
    customStyle?: React.CSSProperties
}
export const Common_ModalContent_Simple = ({content,customStyle}:ContentSimpleProps) =>{
    return(
        <ContentWrapper style={customStyle}>
            {content}
        </ContentWrapper>
    )
}
// ======================================Footer=============================================
const FooterWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 16px;

    height: 45px;
`

interface Common_ModalFooter_SimpleSingleProps {
    confirmText?:string
    action: ()=>void
}

export const Common_ModalFooter_SimpleSingle = ({confirmText='확인',action}:Common_ModalFooter_SimpleSingleProps)=>{
    const onClickConfirm = ()=>{
        action()
    }
    
    return(
        <FooterWrapper>
            <NextButton onClick={onClickConfirm}>{confirmText}</NextButton>
        </FooterWrapper>
    )
}

interface Common_ModalFooter_SimpleDoubleProps {
    cancleText?:string
    confirmText?:string
    customWrapperStyle?: React.CSSProperties
    customCancleStyle?: React.CSSProperties
    customConfirmStyle?: React.CSSProperties
    cancleAction: ()=>void
    confirmAction: ()=>void
}

export const Common_ModalFooter_SimpleDouble = ({cancleText='취소',confirmText='확인',customWrapperStyle,customCancleStyle,customConfirmStyle,cancleAction,confirmAction}:Common_ModalFooter_SimpleDoubleProps)=>{
    const onClickCancle = ()=>{
        cancleAction()
    }
    const onClickConfirm = ()=>{
        confirmAction()
    }
    
    return(
        <FooterWrapper style={customWrapperStyle}>
            <CancleButton style={{width:'96px',...customCancleStyle}} onClick={onClickCancle}>{cancleText}</CancleButton>
            <NextButton style={{width:'96px',...customConfirmStyle}} onClick={onClickConfirm}>{confirmText}</NextButton>
        </FooterWrapper>
    )
}